import PropTypes from 'prop-types'
import React from 'react'

import { isEmpty } from '../../utilities/GeneralUtils'

export const TYPE_LABEL = 'input-holder-label'
export const TYPE_MAIN = 'input-holder-main'
export const TYPE_NOTES = 'input-holder-notes'

/** Component to wrap around an input to add helper notes for that input */

const AInputHolder = ({
  type = TYPE_MAIN,
  formGroup = false,
  wrapperStyle = '',
  children,
}) => {
  let className = type
  if (formGroup) {
    className += ' form-group'
  }

  if (!isEmpty(wrapperStyle)) {
    className += ` ${wrapperStyle}`
  }

  return <div className={className}>{children}</div>
}

AInputHolder.propTypes = {
  /** type of input holder (main, label, or notes).  Default is main.  See AInputHolder.js in components-multi.less for maring details */
  type: PropTypes.string,
  /** whether or not to add form group bottom margin */
  formGroup: PropTypes.bool,
  /** wrapper style.  See AInputHolder.js in components-multi.less for maring details */
  wrapperStyle: PropTypes.string,
  /** input component */
  children: PropTypes.node,
}

export default AInputHolder
